module.exports = __webpack_public_path__ + "static/media/sustainable_mobile.1e751ffc.jpg";